module.exports = __webpack_public_path__ + "static/media/compare.cd52cc4b.svg";